const baseRouter = {
  path: '/main',
  name: 'main',
  component: resolve => require(['@/components/main'], resolve),
  children: [
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/components/index'], resolve),
    },
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['@/components/product'], resolve),
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: resolve => require(['@/components/productDetail'], resolve),
    },
    {
      path: '/achievement',
      name: 'achievement',
      component: resolve => require(['@/components/achievement'], resolve),
    },
    {
      path: '/achievementDetail',
      name: 'achievementDetail',
      component: resolve => require(['@/components/achievementDetail'], resolve),
    },
    {
      path: '/about',
      name: 'about',
      component: resolve => require(['@/components/about'], resolve),
    },
    {
      path: '/career',
      name: 'career',
      component: resolve => require(['@/components/career'], resolve),
    },
    {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/components/contact'], resolve),
    },
    {
      path: '/helloWorld',
      name: 'HelloWorld',
      component: resolve => require(['@/components/HelloWorld'], resolve),
    }
  ]
};
export default baseRouter



// WEBPACK FOOTER //
// ./src/router/base.js